import * as React from 'react'
import { FooterCompact as OriginalFooterCompact_ } from '@betterplace/design-system/page-parts'
function FooterCompact(props) {
  const links = props.text.links.filter((link) => !!link.href)
  return React.createElement(OriginalFooterCompact, { text: { ...props.text, links } })
}

/**
 * @typedef {import('react').ComponentProps<typeof OriginalFooterCompact_>} FooterCompactProps
 */

/**
 * @type {FooterCompactProps}
 */
FooterCompact.railsProps = {
  text: {
    providerInfo: `<%= t('layouts.donations.footer_line_html') %>`,
    links: [
      {
        children: `<%= t('external_urls.imprint_link_text') %>`,
        href: `<%= landingpage_url(Landingpage::Imprint) %>`,
        external: true,
      },
      {
        children: `<%= @config.ultimately_subject_to_levy? ? t('external_urls.transaction_cost_link_text') : '' %>`,
        href: `<%= @config.ultimately_subject_to_levy? ? t('external_urls.transaction_cost_url') : '' %>`,
        external: true,
        className: 'larger-click-area',
      },
      {
        children: `<%= t('external_urls.a11y_statement_link_text') %>`,
        href: `<%= t('external_urls.a11y_statement_url')  %>`,
        external: true,
      },
    ],
  },
}

FooterCompact.railsTemplateFile = 'domains/donate/views/shared/_donation_footer.html.erb'

export const OriginalFooterCompact = OriginalFooterCompact_

export default FooterCompact
